import { Record } from 'immutable';
import ScreenshotRecord from './ScreenshotRecord';
const ScreenshotDetailsRecord = Record({
  screenshot: new ScreenshotRecord(),
  error: undefined,
  isRequesting: false
});
export default ScreenshotDetailsRecord;